import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../lib/firebase";
import "../../styles/detail.css";

const UserCards = ({ user, userId, setUser }) => {
  const [editMode, setEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");

  const cardData = user?.cardApplication;

  const [updatedCard, setUpdatedCard] = useState({
    address: cardData?.address || "",
    applicationNumber: cardData?.applicationNumber || "",
    cardType: cardData?.cardType || "",
    report: cardData?.report || "",
    status: cardData?.status || "pending",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedCard({ ...updatedCard, [name]: value });
  };

  const handleSave = async () => {
    setIsSaving(true);
    setError("");
    setSuccessMessage("");
    try {
      const payload = {
        ...updatedCard,
        applicationNumber: updatedCard.applicationNumber
          ? Number(updatedCard.applicationNumber)
          : "",
      };

      await updateDoc(doc(db, "users", userId), {
        cardApplication: payload,
      });

      setUser({ ...user, cardApplication: payload });
      setEditMode(false);
      setSuccessMessage("Card details updated successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      setError(`Error saving: ${err.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this card application?")) return;
    setIsDeleting(true);
    setError("");
    try {
      await updateDoc(doc(db, "users", userId), { cardApplication: null });
      setUser({ ...user, cardApplication: null });
      setEditMode(false);
      setSuccessMessage("Card application deleted");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      setError(`Error deleting: ${err.message}`);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="profile-grid detail-container">
      <div className="profile-field detail-full-width">
        <div className="profile-header-item detail-header">
          <div>
            <b className="profile-label">Card Application</b>
            <div className="profile-value detail-title-large">
              {cardData?.cardType || "No Active Card"}
            </div>
            <div className="profile-value detail-title-small">
              Application #: {cardData?.applicationNumber || "N/A"}
            </div>
          </div>
        </div>
      </div>

      <div className="profile-field">
        <b className="profile-label">Card Type</b>
        {editMode ? (
          <input
            type="text"
            className="profile-input"
            name="cardType"
            value={updatedCard.cardType}
            onChange={handleChange}
          />
        ) : (
          <div className="profile-value">{cardData?.cardType || "N/A"}</div>
        )}
      </div>

      <div className="profile-field">
        <b className="profile-label">Application Number</b>
        {editMode ? (
          <input
            type="number"
            className="profile-input"
            name="applicationNumber"
            value={updatedCard.applicationNumber}
            onChange={handleChange}
          />
        ) : (
          <div className="profile-value">
            {cardData?.applicationNumber || "N/A"}
          </div>
        )}
      </div>

      <div className="profile-field">
        <b className="profile-label">Address</b>
        {editMode ? (
          <input
            type="text"
            className="profile-input"
            name="address"
            value={updatedCard.address}
            onChange={handleChange}
          />
        ) : (
          <div className="profile-value">{cardData?.address || "N/A"}</div>
        )}
      </div>

      <div className="profile-field">
        <b className="profile-label">Status</b>
        {editMode ? (
          <select
            name="status"
            className="profile-input"
            value={updatedCard.status}
            onChange={handleChange}
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="declined">Declined</option>
            <option value="processing">Processing</option>
          </select>
        ) : (
          <div className="profile-value detail-text-capitalize">
            {cardData?.status || "N/A"}
          </div>
        )}
      </div>

      <div className="profile-field detail-full-width">
        <b className="profile-label">Report</b>
        {editMode ? (
          <textarea
            className="profile-input detail-textarea"
            name="report"
            value={updatedCard.report}
            onChange={handleChange}
            rows={3}
          />
        ) : (
          <div className="profile-value">{cardData?.report || "N/A"}</div>
        )}
      </div>

      <div className="detail-btn-group">
        {editMode ? (
          <>
            <button
              onClick={handleSave}
              className="profile-btn"
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save Changes"}
            </button>
            <button
              onClick={() => setEditMode(false)}
              className="detail-btn-cancel"
            >
              Cancel
            </button>
          </>
        ) : (
          <button onClick={() => setEditMode(true)} className="profile-btn">
            Edit Card Info
          </button>
        )}
        {!editMode && cardData && (
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="detail-btn-delete"
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        )}
      </div>

      {successMessage && (
        <div className="detail-success">
          {successMessage}
        </div>
      )}
      {error && (
        <div className="detail-error">
          {error}
        </div>
      )}
    </div>
  );
};

export default UserCards;